// @flow @jsx h

import { h } from 'preact'
import { Button } from '../Foreground/common/Button'
import { FocusOnEnter } from '../lib/FocusOnEnter'
import { bem } from '@nrk/dh-utils'
import styles from './index.css'
import { byline } from '../../config/text'

type Props = {
  isShowing: boolean,
  toggleModal: () => void
}

const Modal = ({ isShowing, toggleModal }: Props) => {
  return (
    <div class={bem(styles.modal, { hidden: !isShowing })}>
      {isShowing && (
        <ModalContent isShowing={isShowing} toggleModal={toggleModal} />
      )}
    </div>
  )
}

const ModalContent = ({ isShowing, toggleModal }: Props) => {
  return (
    <div class={bem(styles.modal__content)}>
      <div class={styles['modal__button-wrapper']}>
        <Button
          onClick={toggleModal}
          modifiers={['icon', 'inverted']}
          aria-label='Lukk ekstra informasjon'
        >
          <span aria-hidden>
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15 15'>
              <path
                stroke='currentColor'
                strokeLinecap='round'
                d='M2 2l11 11M2 13L13 2'
              />
            </svg>
          </span>
        </Button>
      </div>

      <FocusOnEnter>
        <h2>{byline.title}</h2>
        <ul>
          {byline.content.map(contentItem => {
            return (
              <li key={contentItem.title}>
                <h4>{contentItem.title}</h4>
                <ul>
                  {contentItem.people.map(person => (
                    <li key={person}>{person}</li>
                  ))}
                </ul>
              </li>
            )
          })}
        </ul>
      </FocusOnEnter>
    </div>
  )
}

export { Modal }



// WEBPACK FOOTER //
// ./src/v1/components/Modal/index.js